import { createFileRoute } from '@tanstack/react-router';

import { TemplateTransfersView } from 'src/sections/admin/template-transfers';

export const Route = createFileRoute('/admin-skidog/template-transfers')({
  component: TemplateTransfersPage,
});

function TemplateTransfersPage() {
  return <TemplateTransfersView />;
}
